import { render, staticRenderFns } from "./CustomerReportTabTopup.vue?vue&type=template&id=d5481812&scoped=true"
import script from "./CustomerReportTabTopup.vue?vue&type=script&lang=js"
export * from "./CustomerReportTabTopup.vue?vue&type=script&lang=js"
import style0 from "./CustomerReportTabTopup.vue?vue&type=style&index=0&id=d5481812&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5481812",
  null
  
)

export default component.exports